import { render, staticRenderFns } from "./ChatmessageList.vue?vue&type=template&id=637f693f&"
import script from "./ChatmessageList.vue?vue&type=script&lang=js&"
export * from "./ChatmessageList.vue?vue&type=script&lang=js&"
import style0 from "./ChatmessageList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ChatmessageList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./ChatmessageList.vue?vue&type=style&index=2&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports